import { render, staticRenderFns } from "./PostSection1.vue?vue&type=template&id=5b47d88e&scoped=true"
import script from "./PostSection1.vue?vue&type=script&lang=js"
export * from "./PostSection1.vue?vue&type=script&lang=js"
import style0 from "./PostSection1.vue?vue&type=style&index=0&id=5b47d88e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47d88e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b47d88e')) {
      api.createRecord('5b47d88e', component.options)
    } else {
      api.reload('5b47d88e', component.options)
    }
    module.hot.accept("./PostSection1.vue?vue&type=template&id=5b47d88e&scoped=true", function () {
      api.rerender('5b47d88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blog/PostSection1.vue"
export default component.exports